const headRowsAreas = {
  actions: 'Ações',
  area: 'Departamento'
}

export default headRowsAreas;
